// TODO: DELETE AFTER DEMO

export default {
    state: {
        quests: sessionStorage.getItem('quests') ? JSON.parse(sessionStorage.getItem('quests')) : {}
    },
    mutations: {
        setQuest(state, { id, maxLimit }) {
            if (!state.quests[id]) {
                state.quests[id] = {
                    currentProgress: 0,
                    maxLimit
                }
                sessionStorage.setItem('quests', JSON.stringify(state.quests))
            }
        },
        setCurrentProgress(state, { id, percent }) {
            if (!state.quests[id]) return
            const clampedPercent = Math.min(Math.max(percent, 0), 100)
            const percentProgress = Math.round((state.quests[id].maxLimit * clampedPercent) / 100)
            state.quests[id].currentProgress = Math.min(state.quests[id].currentProgress + percentProgress, state.quests[id].maxLimit)
            sessionStorage.setItem('quests', JSON.stringify(state.quests))
        }
    }
}
